import {FC, useState} from "react";
import {makeStyles} from "tss-react/mui";
import {Box, Stack, Typography} from "@mui/material";
import {ICourseEntity, ICourseEntityPayload} from "@buildwitt/shapeshift-types";
import {useNavigate, useParams} from "react-router-dom";
import Editor from "../../../../components/admin/WYSIWYG/Editor";
import AdminCourseCurriculum from "./AdminCourseCurriculum/CourseCurriculum";
import {IDropzoneFile} from "@buildwitt/shapeshift-common/v1/fileDropzone/fileDropzone";
import {AdminInputText, AdminEntityPageContainer, AdminFileInput, AdminFieldContainer, AdminInputSwitch, AdminInputSelect, AdminFormContainer, ConfirmDeleteEntityDialog} from "@buildwitt/shapeshift-common/v2/admin"
import {cohortCourseValidationDoc} from "../../../../validationDocs/user/cohortCourseValidationDoc";
import {APIState} from "@buildwitt/shapeshift-identity";
import {AdminCoursePageContent} from "@/pages/ManagerView/Pages/Courses/AdminCoursePageContent";
import {AdminCoursePageContent as AdminCoursePageContentNew} from "@/pages/ManagerView/ContentCreation/AdminCoursePageContent";


const useStyles = makeStyles()((_theme) => ({
	adminCoursePage: {},
	adminCoursePageNew: {
		"& > div": {
			width: "980px",
			maxWidth: "100%"
		}
	}
}));

interface IProps {
	newContent?: boolean;
}

const template: ICourseEntityPayload = {
	title: "", slug: "", content: "", description: "", curriculum: [],
	featuredImage: null
}

const contentTypes: string[] = ["Job Training", "Safety", "Personal Development", "Professional Development"]

export const AdminCoursePage: FC<IProps> = ({newContent}) => {
	const {id: courseId} = useParams();
	const {classes} = useStyles();
	const navigate = useNavigate();
	const entityId = courseId ? parseInt(courseId) : undefined;
	const [locale, setLocale] = useState<string>();

	const ICourseEntityToICourseEntityPayload = (e: ICourseEntity): ICourseEntityPayload => {
		const {title, slug, content, id, createdAt, updatedAt, privacy, description, linearProgression} = e
		const featuredImage = e.featuredImage?.id
		const contentType = (e as any).contentType;
		const payload = {
			title, slug, content, id, createdAt, updatedAt, privacy, description, contentType, featuredImage, linearProgression
		}
		return payload;
	}

	const handleOnSaveResponse = (e: APIState<ICourseEntity>): void => {
		if(!e.data)
			return;

		navigate("/admin/courses/" + e.data.id.toString() + "/edit")
	}

	const handleOnSaveResponseNew = (e: APIState<ICourseEntity>): void => {
		if(!e.data)
			return;

		navigate("/admin/courses/" + e.data.id.toString() + "/edit-new")
	}

	const handleOnGetResponse = (entityApiResponse: APIState<ICourseEntity>): void => {
		if(!entityApiResponse.data || entityApiResponse.isLoading)
			return;

		if(entityApiResponse.statusCode === 404){
			navigate("/admin/courses")
		}

		if(!entityApiResponse.data)
			return;

		if(entityId && entityApiResponse.data.id !== entityId){
			navigate("/admin/courses/" + entityApiResponse.data.id.toString() + "/edit?locale=" + entityApiResponse.data.locale)
		}
	}

	const handleOnGetResponseNew = (entityApiResponse: APIState<ICourseEntity>): void => {
		if(!entityApiResponse.data || entityApiResponse.isLoading)
			return;

		if(entityApiResponse.statusCode === 404){
			navigate("/admin/courses")
		}

		if(!entityApiResponse.data)
			return;

		if(entityId && entityApiResponse.data.id !== entityId){
			navigate("/admin/courses/" + entityApiResponse.data.id.toString() + "/edit-new?locale=" + entityApiResponse.data.locale)
		}
	}

	const handleOnDeleteResponse = (deleteApiResponse: APIState<ICourseEntity>): void => {
		if(!deleteApiResponse.data || deleteApiResponse.isLoading)
			return;

		if(deleteApiResponse.statusCode === 200){
			navigate("/admin/courses")
		}
	}

	return newContent ?
		(<Stack className={classes.adminCoursePageNew}>
			<AdminCoursePageContentNew
				courseId={entityId}
				onSaveResponse={handleOnSaveResponseNew}
				onDeleteResponse={handleOnDeleteResponse}
				onGetResponse={handleOnGetResponseNew}
				onLocaleChange={e => setLocale(e)}
				locale={locale}
			/>
		</Stack>
		)
		: (
			<Box className={classes.adminCoursePage}>
				<AdminCoursePageContent
					courseId={entityId}
					onSaveResponse={handleOnSaveResponse}
					onDeleteResponse={handleOnDeleteResponse}
					onGetResponse={handleOnGetResponse}
					onLocaleChange={e => setLocale(e)}
					locale={locale}
				/>
			</Box>
		);
}